import { Component, Input, OnInit } from '@angular/core';
import { ApplicantForm } from '../../forms/applicant.form';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-applicant-regon-data-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  templateUrl: './applicant-regon-data-form.component.html'
})
export class ApplicantRegonDataFormComponent implements OnInit {

  @Input()
  public form: ApplicantForm | undefined;

  public ngOnInit(): void {
    this.form?.regon?.enable();
    this.form?.regon?.setValidators([Validators.required]);
    this.form?.name.enable();

    this.form?.pesel?.disable();
    this.form?.nip?.disable();

    this.form?.firstName?.disable();
    this.form?.lastName?.disable();

    this.form?.fatherName.disable();
    this.form?.motherName.disable();
    this.form?.birthDate.disable();
  }

}
